import { render, staticRenderFns } from "./PolicyCardv2.vue?vue&type=template&id=09715ac2&"
import script from "./PolicyCardv2.vue?vue&type=script&lang=js&"
export * from "./PolicyCardv2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports